import { getAllUrlParams } from '@hll/driver-js-utils';

const state = {
  // 合并所有携带的 url 参数，包含 search 参数和 hash 参数
  urlParams: {},
  // 记录问卷开始作答的时间戳，用于提交时计算问卷回答时间
  startTime: Date.now(),
};

// getters
const getters = {
  urlParams(state) {
    return state.urlParams;
  },
};

// actions
const actions = {
  initAppStore({ commit }) {
    // 合并所有 url 参数，hash 前的参数权重最高
    const allUrlParams = getAllUrlParams(window.location.href);

    // 缓存所有url参数
    commit('setUrlParams', allUrlParams);
  },
};

// mutations
const mutations = {
  setUrlParams(state, urlParameters) {
    state.urlParams = urlParameters;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
